import { useEffect } from "react";
import { useSelector } from "react-redux";

const TotaleCostoProdotto = ({
  prezzoProdotto,
  prezzoOriginale = null,
  totalePrezzoKit = null,
  totalePrezzoKitManodopera = null,
  disableFixedPrice = false,
}) => {
  const genericheTranslation = useSelector(
    (state) => state.translations.generiche
  );
  const siteParams = useSelector((state) => state.siteParams);
  const pageContent = useSelector((state) => state.currentPage.pageContent);
  const iva_default = 1 + parseFloat(siteParams.iva_default) / 100;

  const fixedPriceQuantita = pageContent.detail?.fixedPriceQuantita
    ? pageContent.detail.fixedPriceQuantita
    : 1;

  const fixedPricePrezzoPienoNonIvato = pageContent.detail
    ?.fixedPricePrezzoPienoNonIvato
    ? parseFloat(pageContent.detail.fixedPricePrezzoPienoNonIvato) *
      parseFloat(fixedPriceQuantita)
    : 0;
  const fixedPricePrezzoScontatoNonIvato = pageContent.detail
    ?.fixedPricePrezzoScontatoNonIvato
    ? parseFloat(pageContent.detail.fixedPricePrezzoScontatoNonIvato) *
      parseFloat(fixedPriceQuantita)
    : 0;

  const fixedPriceId = pageContent.detail?.fixedPriceId
    ? disableFixedPrice
      ? 0
      : pageContent.detail.fixedPriceId
    : 0;

  prezzoOriginale =
    fixedPriceId > 0
      ? parseFloat(fixedPricePrezzoScontatoNonIvato) > 0
        ? fixedPricePrezzoPienoNonIvato.toFixed(2)
        : null
      : prezzoOriginale;
  prezzoProdotto =
    fixedPriceId > 0
      ? parseFloat(fixedPricePrezzoScontatoNonIvato) > 0
        ? fixedPricePrezzoScontatoNonIvato.toFixed(2)
        : fixedPricePrezzoPienoNonIvato.toFixed(2)
      : prezzoProdotto;

  useEffect(() => {
    console.log(prezzoOriginale);
    console.log(prezzoProdotto);
  }, [prezzoProdotto, prezzoOriginale]);

  const totalePrezzoOriginale = prezzoOriginale ? (
    <span className="bg-ribola-ivainclusa-gray flex items-baseline flex-col">
      <span className="line-through text-2xl xl:text-xl 3xl:text-2xl">
        ({prezzoOriginale.toString().replace(".", ",")} €
        {" " + genericheTranslation.piuiva.itemName})
      </span>
    </span>
  ) : (
    ""
  );

  const totalePrezzo = prezzoOriginale ? (
    <span className="bg-ribola-ivainclusa-gray text-2xl flex items-baseline flex-col">
      <span>
        ({prezzoProdotto.toString().replace(".", ",")} €
        {" " + genericheTranslation.piuiva.itemName})
      </span>
    </span>
  ) : (
    <span className="bg-ribola-ivainclusa-gray text-2xl flex items-baseline flex-col">
      <span>
        ({prezzoProdotto.toString().replace(".", ",")} €
        {" " + genericheTranslation.piuiva.itemName})
      </span>
    </span>
  );

  const prezzoKit = totalePrezzoKit !== null && totalePrezzoKit > 0 && (
    <span className="bg-ribola-ivainclusa-gray text-base self-center text-lg">
      (+&nbsp;
      {parseFloat(totalePrezzoKit).toFixed(2).toString().replace(".", ",")} €
      {" " + genericheTranslation.piuiva.itemName})
    </span>
  );

  const prezzoKitManodopera = totalePrezzoKitManodopera !== null &&
    totalePrezzoKitManodopera > 0 && (
      <span className="bg-ribola-ivainclusa-gray text-base self-center text-lg">
        (+&nbsp;
        {parseFloat(totalePrezzoKitManodopera)
          .toFixed(2)
          .toString()
          .replace(".", ",")}{" "}
        €{" " + genericheTranslation.piuiva.itemName})
      </span>
    );

  const totalePrezzoOriginaleIvaInclusa = prezzoOriginale ? (
    <span className="text-ribola-congress-blue flex items-baseline flex-col">
      <span className="mr-3 text-xl xl:text-lg 3xl:text-xl">
        {genericheTranslation.totalestatic.itemName.toUpperCase()}
      </span>
      <span className="line-through text-3xl xl:text-2xl 3xl:text-3xl">
        {parseFloat(prezzoOriginale * iva_default)
          .toFixed(2)
          .toString()
          .replace(".", ",")}{" "}
        €
      </span>
    </span>
  ) : (
    ""
  );

  const totalePrezzoIvaInclusa = prezzoOriginale ? (
    <span className="text-ribola-web-orange text-4xl">
      {parseFloat(prezzoProdotto * iva_default)
        .toFixed(2)
        .toString()
        .replace(".", ",")}{" "}
      €{" "}
    </span>
  ) : (
    <span className="text-ribola-congress-blue text-4xl flex items-baseline flex-col">
      <span className="mr-3 text-2xl xl:text-xl 3xl:text-2xl">
        {genericheTranslation.totalestatic.itemName.toUpperCase()}
      </span>
      {parseFloat(prezzoProdotto * iva_default)
        .toFixed(2)
        .toString()
        .replace(".", ",")}{" "}
      €{" "}
    </span>
  );

  const prezzoKitIvaInclusa = totalePrezzoKit !== null && totalePrezzoKit > 0 && (
    <span className="text-ribola-congress-blue text-base self-center text-xl">
      {genericheTranslation.prezzokit.itemName}&nbsp;
      {parseFloat(totalePrezzoKit * iva_default)
        .toFixed(2)
        .toString()
        .replace(".", ",")}{" "}
      €
    </span>
  );

  const prezzoKitManodoperaIvaInclusa = totalePrezzoKitManodopera !== null &&
    totalePrezzoKitManodopera > 0 && (
      <span className="text-ribola-congress-blue text-base self-center text-xl">
        {genericheTranslation.prezzokitmanodopera.itemName}&nbsp;
        {parseFloat(totalePrezzoKitManodopera * iva_default)
          .toFixed(2)
          .toString()
          .replace(".", ",")}{" "}
        €
      </span>
    );

  const testoIvaInclusa = (
    <span className="text-xl">
      {genericheTranslation.testoIvaInclusa.itemName}
    </span>
  );
  const testoIvaEsclusa = (
    <span className="text-md">
      {genericheTranslation.testoIvaEsclusa.itemName}
    </span>
  );

  return (
    <div className="grid grid-cols-60 font-opensanssemibold mt-3 3xl:mt-10 pt-3 3xl:pt-6 border-t border-gray-400 negativePriceContainer">
      <div className="col-span-60 sm:col-span-60 xl:col-span-60 bg-ribola-ivainclusa-gray py-6 px-4 flex-col">
        {testoIvaInclusa}
        <div className="flex sm:items-end items-start justify-between sm:flex-row flex-col">
          {totalePrezzoOriginaleIvaInclusa} {totalePrezzoOriginale}
        </div>
        <div className="flex sm:items-end items-start justify-between sm:flex-row flex-col">
          {totalePrezzoIvaInclusa} {totalePrezzo}
        </div>
        <div className="flex sm:items-end items-start justify-between sm:flex-row flex-col">
          {prezzoKitIvaInclusa} {prezzoKit}
        </div>
        <div className="flex sm:items-end items-start justify-between sm:flex-row flex-col">
          {prezzoKitManodoperaIvaInclusa} {prezzoKitManodopera}
        </div>
      </div>
    </div>
  );
};

export default TotaleCostoProdotto;
